/**
 * Shared overlay recipes.
 *
 * Dropdown surface — the drawn context menu "File Options" 14:20659: Primary BG/80–90 + White/5 layer, 1px White/5,
 * r4, padding 4, shadow 0 8 16 #0000001a, background blur 12.5 → 6.25 px. Used by Menu, Select, MultiSelect
 * (select lists are not drawn, spec §9 Q14).
 */
export const dropdownSurface = [
  'rounded-4 border border-line-subtle bg-elevated bg-[image:linear-gradient(var(--color-subtle),var(--color-subtle))] p-4',
  'shadow-[0_0.5rem_1rem_0_#0000001a] backdrop-blur-[0.390625rem] outline-none',
].join(' ');

/** Menu / list row: h32, padding 0/8, gap 12, r4, 400 14/20 White/90; highlighted row White/10. */
export const dropdownItem = [
  'flex min-h-32 cursor-pointer items-center gap-12 rounded-4 px-8 text-sm text-fg-nav outline-none select-none',
  'data-highlighted:bg-field data-disabled:cursor-not-allowed data-disabled:opacity-40',
].join(' ');

/** Scale + fade used by every anchored popup (Base UI `data-starting-style` / `data-ending-style`). */
export const popupMotion = [
  'origin-(--transform-origin) transition-[opacity,scale] duration-150 ease-standard',
  'data-starting-style:scale-95 data-starting-style:opacity-0 data-ending-style:scale-95 data-ending-style:opacity-0',
].join(' ');
